import React from "react";
import { useContentList, useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";
import MD from "../components/Markdown";
import WikiTabPanel from "../components/wiki/WikiTabPanel";

const WikiPage = () => {
  const { data: wikiHeader } = useContentObject("wiki.header", contentFallback("wiki.header"));
  const { data: theme } = useContentObject("theme.branding", contentFallback("theme.branding"));
  const wikiBg = theme?.bg_wiki || "https://images.unsplash.com/photo-1514539079130-25950c84af65?auto=format&fit=crop&w=1920&q=80";
  const bgOpacity = Math.min(100, Math.max(0, Number(theme?.bg_sections_opacity ?? 20))) / 100;

  return (
    <main className="bg-[#0a0a0d] min-h-screen">
      <div className="relative pt-44 pb-16 overflow-hidden">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${wikiBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: bgOpacity,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0d]/50 via-[#0a0a0d]/80 to-[#0a0a0d]" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 text-center">
          <div className="ornament justify-center inline-flex"><span>{wikiHeader?.eyebrow || "Server Info"}</span></div>
          <h1 className="section-title mt-6 text-4xl md:text-6xl">{wikiHeader?.title || "Wiki del Reino"}</h1>
          <p className="mt-5 max-w-2xl mx-auto text-[#b8b3a8]">{wikiHeader?.subtitle || ""}</p>
        </div>
      </div>

      <section className="relative pb-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <WikiTabPanel layout="sidebar" />
          <CustomWikiSections />
        </div>
      </section>
    </main>
  );
};

function CustomWikiSections() {
  const { items: sections } = useContentList("wiki.sections", []);
  if (!sections.length) return null;
  return (
    <div className="mt-16 space-y-8">
      {sections.map((s, i) => (
        <article key={s.id || s.title || i} id={s.id} className="glass rounded-sm p-7">
          <h3 className="font-display font-bold text-2xl text-[#f0ebe0] mb-4">{s.title}</h3>
          <MD>{s.body}</MD>
        </article>
      ))}
    </div>
  );
}

export default WikiPage;
